import React from 'react'
import { Box } from '@node-space/ui-components'
import { BackgroundGraphic } from './BackgroundGraphic'

export const BackgroundGradient = () => {
  const defaultStyles = 'bottom-0 right-0 top-0'
  const smStyles = 'sm:pb-[100%] sm:bottom-[50%] sm:translate-y-[50%] sm:top-auto'
  const mdStyles = 'md:w-[114%]'
  const classes = `absolute bg-gradient ${defaultStyles} ${smStyles} ${mdStyles}`

  return (
    <Box className="absolute inset-0 overflow-hidden">
      <Box width="full" className={classes} />
      <Box className="absolute right-0 top-0 bottom-0 hidden md:block">
        <BackgroundGraphic />
      </Box>
    </Box>
  )
}
